import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios/index'

import clientSDK from '../../App/ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../App/Util/axiosErrorHandler'
import config from '../../config'
import { IReferral, IApiReferral } from '../interface/IReferreal'
import { referralTransformer } from '../transformer/referralTransformer'

export const getReferral = createAsyncThunk<IReferral, void, IThunkReject<any>>(
  'referralList/fetch',
  async (_, { rejectWithValue }) => {
    let apiData: null | IReferral = null
    try {
      const promise = clientSDK
        .instance()
        .get<IApiReferral>(`account/referral-info`)
      const result = await promise
      apiData = referralTransformer(result.data)
    } catch (error) {
      const handleAxiosError = axiosErrorHandler<any>(res => res)
      const generatedError = handleAxiosError(error as Error | AxiosError)
      return rejectWithValue(generatedError)
    }
    return apiData
  },
)
